<template>
  <div class="contract-list tab-table p-2">
    <contract-table change-permission="change_receipt" delete-permission="delete_receipt"
                    export-permission="export_receipt" :customer-uuid="receipt.customer.uuid" object-name="receipt"
                    :object-uuid="receipt.uuid" />
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import ContractTable from "@/modules/contracts/ContractTable";

  const {mapState} = createNamespacedHelpers('receipts');
  const {mapActions: contractsMapActions} = createNamespacedHelpers('contracts');


  export default {
    name: "Contracts",
    components: {ContractTable},
    computed: {
      ...mapState({
        receipt: state => state.view.currentReceipt,
      }),
    },
    methods: {
      ...contractsMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'receipt',
        extraFilters: {object_uuid: this.receipt.uuid}
      });
    }
  }
</script>

<style scoped>

</style>
